import apiClient from "./axios.config";
import Cookies from "js-cookie";

const vendorsLogin = {
  login: async (credentials) => {
    try {
      const response = await apiClient.post("/vendor/auth", credentials);
      if (response.data?.result?.accessToken) {
        const accessToken = response.data.result.accessToken;
        const role = response.data.result.role;
        Cookies.set("accessToken", accessToken, {
          expires: 7,
          secure: true,
          sameSite: "Strict",
        });
        Cookies.set("userRole", role, { expires: 7 });
        console.log("Access Token Set:", Cookies.get("accessToken"));
      } else {
        console.error("Access token not found in response");
      }
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
  otpVerify: async (ownerData) => {
    try {
      const { phoneNo, otp } = ownerData;
      const response = await apiClient.post(
        `/vendor/auth/verify-otp?phoneNo=${phoneNo}&otp=${otp}`
      );

      const accessToken = response?.data?.result?.accessToken;
      const role = response?.data?.result?.role;

      if (accessToken) {
        Cookies.set("accessToken", accessToken, { expires: 7 });
      }

      if (role) {
        Cookies.set("userRole", role, { expires: 7 }); // ✅ Save role as cookie
      }

      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
  resendOtp: async (ownerData) => {
    try {
      const { phoneNo } = ownerData;
      const response = await apiClient.post(
        `/vendor/auth/resend-otp/${phoneNo}`
      );
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
};

export default vendorsLogin;
